import Container from "../../components/Layout/Container"
import FeaturesSection from "./components/Features"
import { FounderMessage } from "./components/FounderMessage"
import { HeroSection } from "./components/HeroSection"
import { JoinWaitingList } from "./components/JoinWaitingList"
import { WhoWeAre } from "./components/WhoWeAre"

export const Home = () => {
    return (
        <>
            <Container>
                <HeroSection />
                <WhoWeAre />
                {/* <StepSection /> */}
                <FeaturesSection />
            </Container>
            <FounderMessage />
            <Container>
                <JoinWaitingList />
            </Container>
        </>
    )
}